import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import {
  YEAR_OVER_YEAR_COLUMNS,
  SORT_TYPES,
  getDefaultVisibleColumns,
  getDefaultHiddenColumns,
} from '../constants/yearOverYearColumnsConfig';
import { compactCurrency } from '../utils/reportingUtils';

// The fiscal-year links to the full-page drill-down listing that year's gifts.
const drilldownHref = (teamId, row) =>
  `/teams/${teamId}/reporting/donations/year-over-year/gifts?drilldown_id=${row.year}`;

const CONFIG = {
  pageTitle: 'Year-over-Year Comparison',
  pageSubtitle: 'Total raised, donors, average gift and new donors compared across fiscal years. Shows the last three fiscal years by default — widen the date range to include more.',
  sidebarKey: 'donations_year_over_year',
  defaultPreset: 'this_year',
  // Single option => the "View by" toggle is hidden; giving has no event-date mode.
  dateModeOptions: [{ key: 'order_date', label: 'Order Date' }],

  columns: YEAR_OVER_YEAR_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns,
  getDefaultHiddenColumns,
  localStorageKey: (teamId) => `reportingYearOverYearColumns_${teamId}`,
  firstColumnId: 'year',
  defaultSortRules: [{ field: 'year', direction: 'desc' }],

  showFilters: false,
  kpiFromDetailResponse: true,
  detailEndpoint: (teamId) => `/teams/${teamId}/reporting/donations/year-over-year/data.json`,
  detailResponseKey: 'years',
  exportBasePath: (teamId) => `/teams/${teamId}/reporting/donations/year-over-year/export`,
  detailErrorMessage: 'Failed to load year-over-year data.',
  detailTableTitle: 'Fiscal Years',
  emptyMessage: 'No donations found.',
  searchPlaceholder: 'Search years...',
  paginationLabel: 'years',
  itemLabel: (count) => `year${count !== 1 ? 's' : ''}`,

  buildFilterGroups: () => [],
  buildDetailApiFilters: () => ({}),
  filterTitle: 'Filter',
  filterSubtitle: '',

  buildKpiCards: (current, prior) => {
    const p = prior || {};
    return [
      { label: 'Total Raised', value: compactCurrency(current.total_raised || 0), current: current.total_raised || 0, prior: p.total_raised || 0 },
      { label: 'Donors', value: (current.donor_count || 0).toLocaleString(), current: current.donor_count || 0, prior: p.donor_count || 0 },
      { label: 'Average Gift', value: compactCurrency(current.average_gift || 0), current: current.average_gift || 0, prior: p.average_gift || 0 },
      { label: 'New Donors', value: (current.new_donors || 0).toLocaleString(), current: current.new_donors || 0, prior: p.new_donors || 0 },
    ];
  },
  kpiGridColumns: 4,

  renderCellValue: (col, row, { currencyFormatter: cf, team }) => {
    switch (col.id) {
      case 'year': return (
        <a href={drilldownHref(team.id, row)} style={{ color: 'var(--sl-fg-brand, #1982c4)', fontWeight: 600 }}>
          {row.year}
        </a>
      );
      case 'total_raised': return cf.format(row.total_raised || 0);
      case 'donor_count': return (row.donor_count || 0).toLocaleString();
      case 'average_gift': return cf.format(row.average_gift || 0);
      case 'new_donors': return (row.new_donors || 0).toLocaleString();
      default: return '—';
    }
  },
};

function ReportingDonationsYearOverYearPage(props) {
  return <SalesDetailPage {...props} config={CONFIG} />;
}

export default ReportingDonationsYearOverYearPage;
